import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import TabsList from "./TabsList";

export const FINANCE_TAB_REPORTS = "reports";
export const FINANCE_TAB_ACCOUNTS = "accounts";
export const FINANCE_TAB_TRANSACTION = "transaction";

/**
 * Cross-route tabs between Financial Reports, Financial Accounts, and Financial Transaction.
 */
export default function FinanceSectionTabs({ activeTab }) {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const showReports = hasPermission && hasPermission("menu.financial_reports");
  const showAccounts = hasPermission && hasPermission("menu.financial_accounts");
  const showTransaction = hasPermission && hasPermission("menu.transaction");

  return (
    <TabsList className="section-tabs-list" role="tablist" aria-label="Finance sections">
      {showReports ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === FINANCE_TAB_REPORTS}
          className={`tab-btn ${activeTab === FINANCE_TAB_REPORTS ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== FINANCE_TAB_REPORTS) navigate("/FinancialReports");
          }}
        >
          Financial Reports
        </button>
      ) : null}
      {showAccounts ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === FINANCE_TAB_ACCOUNTS}
          className={`tab-btn ${activeTab === FINANCE_TAB_ACCOUNTS ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== FINANCE_TAB_ACCOUNTS) navigate("/FinancialAccounts");
          }}
        >
          Financial Accounts
        </button>
      ) : null}
      {showTransaction ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === FINANCE_TAB_TRANSACTION}
          className={`tab-btn ${activeTab === FINANCE_TAB_TRANSACTION ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== FINANCE_TAB_TRANSACTION) navigate("/Transaction");
          }}
        >
          Financial Transaction
        </button>
      ) : null}
    </TabsList>
  );
}
